import { useQuery } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';
import type { ReportListFilter } from '../types/reportBuilder';

/**
 * GET /api/eraf/report-builder/reports — 리포트 정의 목록 (REPORT_READ)
 * queryKey: ['report-builder', 'list', filters]
 */
export function useReportBuilderList(filters: ReportListFilter) {
  return useQuery({
    queryKey: ['report-builder', 'list', filters],
    queryFn: () =>
      reportBuilderApi.list({
        name: filters.name,
        dataSource: filters.dataSource,
        status: filters.status || undefined,
        ownerScope: filters.ownerScope ?? 'mine',
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'createdAt,desc',
      }),
    staleTime: 30_000,
  });
}
